// Quelle: /opt/lilasprojekte/frontend/src/components/app/MobilLeiste.tsx (Stand 2026-09-29)
// Geändert (SPEC 03 §7.2.4): die vier Ziele Auswertung · Prüfen · Themen · Exporte; `reiterAn`
// durch einen örtlichen Präfixtest ersetzt; Texte deutsch.
// Geändert (E32): Ziele mit `mobil: false` (die Karte) stehen nur in der Kopfleiste.
// Geändert (01.10.): fünfter Eintrag „Suchen“ — die Befehlssuche (Seiten, Werkzeuge, Codes, KI); die
// Kopfleiste blendet ihren Suchknopf ≤ 859 px aus, hier bleibt sie erreichbar.
// ============================================================
// Die Reiterleiste am unteren Rand — nur auf dem Telefon: 62 px hoch, 14 px vom Rand, Glas.
//
// Die Komponente entscheidet SELBST, ob sie erscheint: `useMobil()` statt einer CSS-Regel,
// damit Dock und Chat ihre Höhe aus derselben Wahrheit rechnen können und nicht aus einem
// Element, das zwar im Baum steht, aber unsichtbar ist.
// ============================================================
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../ui";
import { useMobil } from "../../hooks/useMedienabfrage";
import { useIch } from "../../hooks/useIch";
import { TX } from "../../lib/texte";
import { oeffneBefehlssuche, useBefehlssuche } from "./Befehlssuche";
import { navZiele } from "./navigation";

export function MobilLeiste({ V }: { V: string | null }) {
  const mobil = useMobil();
  const { pathname } = useLocation();
  const { data: ich } = useIch();
  const sucheOffen = useBefehlssuche((s) => s.offen);
  if (!mobil) return null;

  return (
    <nav className="mobil-leiste glass-strong" aria-label={TX.shell.nav}>
      {navZiele(V, ich)
        .filter((p) => p.mobil !== false)
        .map((p) => {
          const an = p.an.test(pathname);
          return (
            <Link key={p.id} to={p.zu} aria-current={an ? "page" : undefined} className={`ring-focus${an ? " aktiv" : ""}`}>
              <Icon name={p.icon} size={21} />
              {p.text}
            </Link>
          );
        })}
      <button
        type="button"
        className={`bs-mobil ring-focus${sucheOffen ? " aktiv" : ""}`}
        aria-haspopup="dialog"
        aria-expanded={sucheOffen}
        title={TX.befehle.knopfTitel}
        onClick={oeffneBefehlssuche}
      >
        <Icon name="magnifying-glass" size={21} />
        {TX.befehle.knopf}
      </button>
    </nav>
  );
}
